// Prefer a usable field in the form body over navigation and dismissal controls in its header.
export const focusFirstField = (popup: HTMLElement | null): HTMLElement | null => {
  const fields = popup?.querySelectorAll<HTMLElement>(
    'main input:not([type="hidden"]), main textarea, main select, main [role="combobox"]',
  )
  const field = Array.from(fields ?? []).find(
    (field) =>
      !field.matches(':disabled, [aria-disabled="true"], [tabindex="-1"]') &&
      !field.closest('[hidden], [inert]') &&
      getComputedStyle(field).display !== 'none' &&
      getComputedStyle(field).visibility !== 'hidden',
  )
  // A searchable select unfolds its list on focus: once filled, the window keeps the focus instead.
  return field && !(field instanceof HTMLInputElement && field.matches('[role="combobox"]') && field.value)
    ? field
    : null
}
